import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import "./modals-styles.scss"
const ConvertSubscriptionModal = ({show,hideModal}) => {
  return (
    <Modal
    show={show}
    dialogClassName=""
    className="modal-height-auto modal-radius-8 "
    aria-labelledby=""
    centered
    scrollable
    onHide={hideModal}
  >
    <Modal.Body className='p-3'>
    <div className='f-16 f-500 mb-3'>Convert M3 Networks ltd. to paid subscription?</div>
    <div className='f-14 f-500 mb-3'>This account will be converted to a paid subscription.</div>
    <div className='f-14 f-darkgrey mb-2'>Suitable subscription</div>
 
 <div className='bg-grey radius-4 d-flex align-items-center justify-content-between p-2'>
    <div>
        <div className='f-14 f-black f-500'>Starter</div>
        <div   className='f-12 f-darkgrey f-500'>Up to 100 clients, 10 prospects</div>
    </div>
    <div  className='f-14 f-black f-500'>$295 /month</div>

 </div>
</Modal.Body>

<Modal.Footer className='p-2 d-flex align-items-center justify-content-end border-none'>
    <Button className='hg-cancel-btn mr-2'>Cancel</Button>
    <Button className='hg-blue-btn'>Convert</Button>

</Modal.Footer>
  </Modal>
  )
}

export default ConvertSubscriptionModal